import { render } from "./blog-article-creation-form.vue?vue&type=template&id=55ad78e7"
import script from "./blog-article-creation-form.vue?vue&type=script&lang=js"
export * from "./blog-article-creation-form.vue?vue&type=script&lang=js"

import "./blog-article-creation-form.vue?vue&type=style&index=0&id=55ad78e7&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__